<template>
  <div class="footer">
    <div class="footer-ctn">
      <div>
        <a href="https://www.priintr.com/piixme" target="_blank">{{$t("footer.poweredBy") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies

export default {
  name: 'Footer',

  components: {},
  directives: {},

  props: {

    displayDemoText: { type: Boolean, required: false, default: true },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    displayContact() {

    },
  },
};
</script>


<style>

</style>

<style  lang="scss" >
.footer {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 2rem;
  text-align: center;
  padding-bottom: 1.2rem;


  .footer-ctn {
    /*
    display: flex;

    justify-content: space-between;
    align-items: center;*/
     padding-top: 2rem;
    font-size: 0.9em;
  }


 a{

}

  a:hover {
    text-decoration: underline !important;
  }

  .fb-btn {
    display: inline-block;
    width: 25px;
    height: 25px;
    background: url('../assets/fb.png');
    background-size: 25px 25px;
  }

  .insta-btn {
    display: inline-block;
    width: 25px;
    height: 25px;
    margin: 0 0.6rem;
        margin-right: 0.8rem;
    background: url('../assets/insta.png');
    background-size: 25px 25px;
  }

  .mail-btn {
    display: inline-block;
    width: 25px;
    height: 25px;
    background: url('../assets/email.png');
    background-size: 25px 25px;
  }
}
</style>
